/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import api from './api';

export const getOrientationStatus = async () => (await api.get('/orientation/status')).data;
export const consumeOrientation = async (reason = null) => (await api.post('/orientation/consume', { reason })).data;

export const generateColleagueRef = async () => (await api.post('/referrals/generate')).data;
export const listMyReferrals = async () => (await api.get('/referrals/my')).data;
export const redeemColleagueRef = async (code) => (await api.post('/referrals/redeem', { code })).data;

export const getEcmCatalog = async () => (await api.get('/ecm/catalog')).data;
export const getEcmArticle = async (id) => (await api.get(`/ecm/article/${id}`)).data;
export const submitEcmQuiz = async (id, answers) => (await api.post(`/ecm/article/${id}/quiz`, { answers })).data;
